import React, { useState } from 'react';
import { Formik } from 'formik';
import { Button } from '../../../../shared/components/Button';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from 'react-bootstrap';
import SimpleModal from '../../../../shared/components/Modal/SimpleModal';
import { changePassword, clearMsg } from '../../../../redux/actions/authActions';


const NewPasswordForm = ({ setModal }) => {
  const [showPassword, setShowPassword] = useState(true);
  const [showPassword1, setShowPassword1] = useState(true);
  const [isOpen, setisOpen] = useState(false);
  const { message } = useSelector(state => state.message);
  const { statusCode } = useSelector(state => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const ChangePassword = (user) => {
    setIsLoading(true);
    dispatch(changePassword(user.oldPass, user.newPass, user.otp)).then(() => {
      setisOpen(true);
      setTimeout(() => {
        dispatch(clearMsg());
        setModal(false);
      }, 3000);
    })
      .catch(() => {
        setIsLoading(false);
        setTimeout(() => {
          dispatch(clearMsg());
        }, 3000);
      });
  };
  return (
    <>
      <Formik
        initialValues={{
          otp: '',
          oldPass: '',
          newPass: '',
          email: '',
        }}
        onSubmit={(values) => {
          ChangePassword(values);
        }}
        validate={(values) => {
          const errors = {};
          const passwordRegex = /(?=.*[0-9])/;
          if (!values.otp) {
            errors.otp = 'Required';
          } else if (values.otp.length < 4) {
            errors.otp = 'OTP must be at least 4 characters';
          }
          if (!values.oldPass) {
            errors.oldPass = 'Required';
          } else if (values.oldPass.length < 8) {
            errors.oldPass = 'Password must be 8 characters long';
          } else if (!passwordRegex.test(values.oldPass)) {
            errors.oldPass = 'Invalid Password must contain one number';
          }
          if (!values.newPass) {
            errors.newPass = 'Required';
          } else if (values.newPass.length < 8) {
            errors.newPass = 'Password must be 8 characters long';
          } else if (!passwordRegex.test(values.newPass)) {
            errors.newPass = 'Invalid Password must contain one number';
          } else if (values.newPass === values.oldPass) {
            errors.newPass = 'New Password should be different';
          }
          return errors;
        }}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
          } = props;
          return (
            <form onSubmit={handleSubmit} style={{ marginTop: '1rem' }}>
              <StyledAlert
                variant={statusCode === 200 ? 'success' : 'danger'}
                show={message !== undefined}
                style={{
                  marginTop: '1rem', width: '100%', textAlign: 'center',
                }}
                onClose={() => dispatch(clearMsg())}
                dismissible
                bordered
                icon
              >
                {message}
              </StyledAlert>
            <FieldsRow>
        
              <InputDiv>
                <InputLabel htmlFor="oldPass">Old Password</InputLabel>
                <FieldDiv>
                  <IconDiv><span className="lnr lnr-lock text-white" /></IconDiv>
                  <input
                    name="oldPass"
                    type={showPassword ? 'password' : 'text'}
                    placeholder="Enter old password"
                    value={values.oldPass}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.oldPass && touched.oldPass ? 'error' : ''}
                  />
                </FieldDiv>
                <ShowPasswordButton
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? 'Show' : 'Hide'}
                </ShowPasswordButton>
                {errors.oldPass && touched.oldPass && (
                  <Error className="input feedback">{errors.oldPass}</Error>
                )}
              </InputDiv>
              <InputDiv>
                <InputLabel htmlFor="newPass">New Password</InputLabel>
                <FieldDiv>
                  <IconDiv><span className="lnr lnr-lock text-white" /></IconDiv>
                  <input
                    name="newPass"
                    type={showPassword1 ? 'password' : 'text'}
                    placeholder="Enter new password"
                    value={values.newPass}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.newPass && touched.newPass ? 'error' : ''}
                  />
                </FieldDiv>
                <ShowPasswordButton
                  type="button"
                  onClick={() => setShowPassword1(!showPassword1)}
                >
                  {showPassword1 ? 'Show' : 'Hide'}
                </ShowPasswordButton>
                {errors.newPass && touched.newPass && (
                  <Error className="input feedback">{errors.newPass}</Error>
                )}
              </InputDiv>
              <InputDiv>
                <InputLabel htmlFor="otp">OTP</InputLabel>
                <FieldDiv>
                <IconDiv><span className="lnr lnr-lock text-white" /></IconDiv>
                <input
                    name="otp"
                    type="text"
                    placeholder="Enter OTP"
                    value={values.otp}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.otp && touched.otp ? 'error' : ''}
                    maxLength={6}
                    inputMode="numeric"
                  />
                </FieldDiv>
                {errors.otp && touched.otp && (
                  <Error className="input feedback">{errors.otp}</Error>
                )}
              </InputDiv>
            </FieldsRow>

              <FormButton variant="outline-primary" type="submit">
                {isLoading ? 'Loading....' : 'Update'}
              </FormButton>

            </form>
          );
        }}
      </Formik>
      <SimpleModal isActive={isOpen} onClose={() => setisOpen(false)}>
        <ModalDiv>

          <h4
            className="subhead"
            style={{
              padding: '5px', fontSize: '18px', fontWeight: '700', textAlign: 'center', marginBottom: '1rem', color: 'white',
            }}
          >{message}
          </h4>

        </ModalDiv>
      </SimpleModal>
    </>
  );
};

export default NewPasswordForm;

const FieldsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  margin-top: 1.5rem;
  
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 1.5rem;
  }
`;

const InputDiv = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  color: white;
  padding: 0;
  font-size: 14px;
  align-items: flex-start;
  min-width: 0;
`;

const InputLabel = styled.label`
  color: white;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
  width: 100%;
`;


const Error = styled.div`
  color: #ff4861;
  padding: 4px 0px;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
`;

const ShowPasswordButton = styled.button`
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  padding: 6px 0;
  cursor: pointer;
  transition: color 0.2s ease;
  margin-top: 4px;
  align-self: flex-start;
  
  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
  
  &:focus {
    outline: none;
  }
`;

const FormButton = styled(Button)`
  color: white;
  margin-top: 1.5rem;
  min-width: 150px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
`;
const Grid = styled.div`
 display: grid;
 grid-template-columns: 6rem 12rem;
 grid-gap: 1rem;
 width:100%;
 margin-bottom: 1rem;
 align-items: baseline;

 @media screen and (max-width: 876px) {
 grid-template: none;
 }
 `;
const FieldDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  
  input {
    flex: 1;
    padding: 10px 14px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-left: none;
    border-radius: 0 6px 6px 0;
    color: white;
    font-size: 14px;
    outline: none;
    transition: all 0.2s ease;
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
    
    &:focus {
      border-color: rgba(255, 255, 255, 0.4);
      background: rgba(255, 255, 255, 0.08);
    }
    
    &.error {
      border-color: #ff4861;
    }
  }
`;

const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  background: #3b3b4f;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-right: none;
  border-radius: 6px 0 0 6px;
  min-width: 45px;
  font-size: 16px;
`;
const ModalDiv = styled.div`
height: 9rem;
justify-content: space-between;
display: flex;
align-items: center;
flex-direction: column;
`;
const getMainColor = (color) => {
  switch (color) {
    case 'success':
      return '#c1f9c1';
    case 'danger':
      return '#f1beb0';
    default:
      return '#f1beb0';
  }
};

const getLightColor = (color) => {
  switch (color) {
    case 'success':
      return '#22bb33';
    case 'danger':
      return '#ff4861';
    default:
      return '#f88e7d';
  }
};

const StyledAlert = styled(Alert).withConfig({
  shouldForwardProp: prop => !['bordered', 'neutral', 'colored'].includes(prop),
})`
  
  background-color: ${props => (getMainColor(props.variant))};
  border-color: ${props => (getMainColor(props.variant))};
  color: ${props => (getLightColor(props.variant))};
 
`;
